import { useEffect, useState } from "react";

import { useLocation } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { FILTER } from "@/constants";
import Filters from "@/containers/Filters";
import useFilterParams from "@/hooks/useFilterParams";
import { SearchFilter } from "@/types/SearchFilter";
import { ListFilterIcon } from "lucide-react";
import { Trans } from "@lingui/react/macro";

// List of filters that should count towards the total filter count
const COUNTABLE_FILTERS: Array<keyof SearchFilter> = [
  FILTER.CHANNEL_NAME,
  FILTER.FREETEXT,
  FILTER.CHANNEL_TYPE,
  FILTER.LANGUAGE,
  FILTER.SENTIMENT,
  FILTER.MIN_REACH,
  FILTER.MENTION_KIND,
  FILTER.INSIGHT_TYPES,
  FILTER.INSIGHT_ID,
];

// count applied filters.
const countAppliedFilters = (filters: SearchFilter) => {
  const count = 0;

  return COUNTABLE_FILTERS.reduce((total = 0, key) => {
    const f = filters?.[key];
    return total + (f ? (Array.isArray(f) ? f.length : 1) : 0);
  }, count);
};
type FilterButtonProps = { className?: string };

const FilterButton: React.FunctionComponent<FilterButtonProps> = () => {
  const [open, setOpen] = useState(false);
  const [filters, setFilters] = useFilterParams();

  const { pathname } = useLocation();
  const appliedFilterCount = countAppliedFilters(filters);

  // Close the filter when the user routes away
  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <>
      <Button
        data-count={appliedFilterCount}
        onClick={() => setOpen((v) => !v)}
        data-testid="filter-button"
        type="button"
      >
        <Trans>Filter</Trans>
        <ListFilterIcon />
      </Button>

      {appliedFilterCount > 0 && (
        <Button variant="secondary" onClick={() => setFilters({}, true)}>
          <Trans>Nollställ filter</Trans> ({appliedFilterCount})
        </Button>
      )}

      <Filters open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default FilterButton;
